import { EditResponsibleTypesOutDto, EditResponsibleTypesInDto } from '../../../types/responsible-types.dto'

export const EDIT_RESPONSIBLE_TYPES = 'EDIT_RESPONSIBLE_TYPES'
export const EDIT_RESPONSIBLE_TYPES_SUCCESS = 'EDIT_RESPONSIBLE_TYPES_SUCCESS'
export const EDIT_RESPONSIBLE_TYPES_ERROR = 'EDIT_RESPONSIBLE_TYPES_ERROR'
export const RESET_EDIT_RESPONSIBLE_TYPES = 'RESET_EDIT_RESPONSIBLE_TYPES'

export interface EditResponsibleTypes {
  type: typeof EDIT_RESPONSIBLE_TYPES
  payload: EditResponsibleTypesOutDto
}

export interface EditResponsibleTypesSuccess {
  type: typeof EDIT_RESPONSIBLE_TYPES_SUCCESS
  payload: EditResponsibleTypesInDto
}

export interface EditResponsibleTypesError {
  type: typeof EDIT_RESPONSIBLE_TYPES_ERROR
  payload: string | boolean
}

export interface ResetEditResponsibleTypes {
  type: typeof RESET_EDIT_RESPONSIBLE_TYPES
  payload: null
}
export interface State {
  data: EditResponsibleTypesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditResponsibleTypes | EditResponsibleTypesSuccess | EditResponsibleTypesError | ResetEditResponsibleTypes
